import { S as Swiper } from './swiper-core-BXF75Fx2.js';
import { N as Navigation } from './navigation-BvT7k6pb.js';
import { P as Pagination } from './pagination-z4kt-BHd.js';
import './create-element-if-not-defined-BFxMbgz9.js';

class ProductMediaSwiper extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper('.swiper--media', {
      modules: [Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}

customElements.define('product-media-swiper', ProductMediaSwiper);
